import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace, getZIndex} from '../../common/utils';

var _createNamespace = createNamespace('overlay'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    model: {
        prop: 'show',
        event: 'change'
    },
    name: getComponentName('Overlay'),
    props: {
        show: Boolean,
        duration: {
            type: [Number, String],
            default: 0
        },
        zIndex: {
            type: [Number, String],
            default: function _default() {
                return getZIndex();
            }
        },
        transparent: {
            type: Boolean,
            default: false
        },
        container: {
            type: Function,
            default: function _default() {
                return document.body;
            }
        }
    },
    data: function data() {
        return {
            isMounted: false
        };
    },
    watch: {
        show: function show(val) {
            if (val) {
                this.handleDuration();
                this.container().classList.add('no-scroll');
                document.getElementsByTagName('html')[0].classList.add('no-scroll');
            } else {
                this.container().classList.remove('no-scroll');
                document.getElementsByTagName('html')[0].classList.remove('no-scroll');
            }
        },
        container: function container(before, after) {
            var _a;

            this.$el.parentNode.removeChild(this.$el);
            (_a = after()) === null || _a === void 0 ? void 0 : _a.appendChild(this.$el);
        }
    },
    updated: function updated() {
        if (!this.isMounted) {
            this.container().appendChild(this.$el);
            this.isMounted = true;
        }
    },
    render: function render() {
        var h = arguments[0];
        var zIndex = this.$props.zIndex;
        var classes = {};

        if (this.transparent) {
            classes['transparent'] = 'transparent';
        }

        return h(
            'transition',
            {
                attrs: {
                    duration: '250',
                    name: 'mai-overlay'
                }
            },
            [
                h(
                    'div',
                    {
                        class: b(classes),
                        on: {
                            click: this.handleClick
                        },
                        style: {
                            'z-index': zIndex
                        },
                        directives: [
                            {
                                name: 'show',
                                value: this.show
                            }
                        ]
                    },
                    [this.$slots.default]
                )
            ]
        );
    },
    methods: {
        handleDuration: function handleDuration() {
            var _this = this;

            if (this.duration > 0) {
                this.timer = setTimeout(function() {
                    _this.close();

                    _this.timer && clearTimeout(_this.timer);
                }, this.duration);
            }
        },
        close: function close() {
            this.$emit('change', false);
        },
        handleClick: function handleClick() {
            this.$emit('click');
            this.$emit('overlay-click');
        }
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
